module.exports = __webpack_public_path__ + "static/media/avatars_other_29.8886229c.png";